import equal from 'lodash.isequal';
/**
 * Check equality (deep)
 */
export const isEqual = (obj1, obj2) => equal(obj1, obj2);
/**
 * No own properties? -> return null
 */
export const getNullableObject = (object, nullable = false) => nullable && isObject(object) && !Object.keys(object).length ? null : object;
/**
 * Is value Object?
 */
export const isObject = (item) => !!(item && typeof item === 'object' && !Array.isArray(item));
/**
 * Cast Boolean from other types
 */
export const castBoolean = (value) => {
    if ([0, 'false', false].includes(value)) {
        return false;
    }
    if ([1, 'true', true].includes(value)) {
        return true;
    }
    return null;
};
/**
 * Browser detection helpers
 */
export const browser = {
    isSafari: () => navigator.userAgent.includes('Safari/') &&
        !navigator.userAgent.includes('Chrome/') &&
        !navigator.userAgent.includes('Chromium/'),
    isFirefox: () => navigator.userAgent.includes('Firefox/') && !navigator.userAgent.includes('Seamonkey/'),
};
